const config = {
    localeValues: {
        english: 'en',
        armenian: 'hy',
        russian: 'ru',
    },
    roles: {
        admin: 'ADMIN',
        manager: 'MANAGER',
        editor: 'EDITOR',
    }
}

export default config;